import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { SwipeToBuy, TravelAssistance } from '../../wizumen-models';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { SwipeToBuyService } from 'projects/common/services/swipe-to-buy.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import {LoaderComponent} from '@shopping-angular-components/loader';

@Component({
  selector: 'wizumen-travel-assistance',
  template: `
    <div class="travel-assistance-container">
      <p class="travel-assistance-title">{{travelAssistance.title}}</p>
      <div class="eva-3-card travel-assistance-card" (click)="fetchAssistanceModal()">
        <div class="travel-assistance-label">
          <i class="eva-3-icon-assistances-ui -eva-3-icon-md"></i>
          <p class="travel-assistance-text">{{travelAssistance.link.title}}</p>
        </div>
        <span class="eva-3-driver -benefits">
          <span class="driver-text">{{travelAssistance.link.auxiliary_text}}</span>
        </span>
      </div>
    </div>
  `,
  styleUrls: ['./wizumen-travel-assistance.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenTravelAssistanceComponent implements OnInit {
  @Input() travelAssistance: TravelAssistance;
  @Input() locale: string;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() flow: string;


  assistanceModalData: SwipeToBuy | null = null;

  constructor(private landingModelService: LandingModelService, private swipeToBuyService: SwipeToBuyService, private upaService: UpaService) { }

  ngOnInit() {
    this.upaService.trackView({
      label: "XSELL_ASSISTANCE-show-travelAssistance-WIZUMEN_NEW",
      uniqueId: this.uniqueId,
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.BUTTON,
      href: this.travelAssistance.link.url
    }, 'view-incentive');
  }

  async fetchAssistanceModal() {
    this.upaService.trackClickTopic({
      label: "XSELL_ASSISTANCE-click-travelAssistance-WIZUMEN_NEW",
      uniqueId: this.uniqueId,
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      target: UpaTarget.BUTTON,
      href: this.travelAssistance.link.url
    });

    if (this.assistanceModalData) {
      this.openAssistanceModal(this.assistanceModalData);
      return;
    }

    const upaData = window.upaData;
    const webview = this.landingModelService.getLandingModel().webview;
    const domain = webview ? this.extractDomain(window.location.host) : upaData.dn;

    const params = {
      locale: this.locale,
      channel: upaData.ch,
      domain: domain,
      trackerId: upaData.userid,
      socialId: upaData.despegarid,
      webview: webview.toString(),
      openedOnDemand: "true",
    };

    try {
      LoaderComponent.showLoaderEvent.emit(true);
      const assistance: SwipeToBuy = await this.swipeToBuyService.getAssistanceModal(params);
      LoaderComponent.showLoaderEvent.emit(false);

      if (assistance && Object.keys(assistance).length === 0) {
        return;
      }

      this.assistanceModalData = assistance;
      this.openAssistanceModal(assistance);

    } catch (error) {
      console.error('Error fetching assistance modal', error);
    }

  }

  openAssistanceModal(assistance: SwipeToBuy) {
    const openedFromCTA = true;
    this.swipeToBuyService.openModal({
      ...(assistance?.upa_data || {}),
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      uniqueId: this.uniqueId,
      flow: this.flow
    }, assistance, openedFromCTA);
  }

  extractDomain(url: string): string | null {
    const regex = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?([^:\/?\n]+)(?::\d+)?/;
    const match = url.match(regex);
    return match ? match[1] : '';
  }
}
